import { render, staticRenderFns } from "./DesarrolloElemento.vue?vue&type=template&id=2c6cb084&scoped=true"
import script from "./DesarrolloElemento.vue?vue&type=script&lang=js"
export * from "./DesarrolloElemento.vue?vue&type=script&lang=js"
import style0 from "./DesarrolloElemento.vue?vue&type=style&index=0&id=2c6cb084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cb084",
  null
  
)

export default component.exports